import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../components/AuthProvider';
import { showTemporaryMessage } from "../components/Message";

import CreateBearerStep1 from '../components/CreateBearerStep1';
import CreateBearerStep2 from '../components/CreateBearerStep2_Diseases';
import CreateBearerStep3 from '../components/CreateBearerStep3_Age';
import CreateBearerStep4 from '../components/CreateBearerStep4_Sex';
import CreateBearerStep5 from '../components/CreateBearerStep5_BloodType';

/**
 This page has two subpages:
  - Step 1: Name of bearer
  - Step 2: Diseases of bearer (up to 3)
*/

import {
	useNavigate
} from "react-router-dom";

import {
	create_bearer,
	update_bearer
} from "../tools-network";

const CreateBearer = ({onBearerCreated, onCancel}) => {
	const { t } = useTranslation();

	const { userType, loginToken, userId } = React.useContext(AuthContext);

	const [currentStep, setCurrentStep] = useState(1);
	const [isLoading, setIsLoading] = useState(false);

	const [name, setName]		= useState('');
	const [isVerbal, setIsVerbal] = useState(true);
	const [birthYear, setBirthYear] = useState('-1');
	const [sex, setSex] = useState('unspecified');
	const [bloodType, setBloodType] = useState('unspecified');
	const [diseases, setDiseases] = useState([]);

	const onBearerCreatedClicked = async () => {
		if (isLoading) return; // Prevent double-clicking
		setIsLoading(true);
		try {
			const res_create = await create_bearer(loginToken, name, isVerbal);
			if(res_create.success) {
				showTemporaryMessage(t("bearer_successfully_created"), " ", 'success');
			} else {
				showTemporaryMessage("Creating bearer FAILED!", res_create.msg, 'danger');
				setIsLoading(false);
				return;
			}
			// Update bearer with additional fields and diseases
			const request_body = {};
		if (birthYear && birthYear !== '-1') request_body.birth_year = parseInt(birthYear);
		if (sex && sex !== 'unspecified') request_body.sex = sex;
		if (bloodType && bloodType !== 'unspecified') request_body.blood_type = bloodType;
			if (diseases.length > 0) request_body.diseases = diseases;
			
			if (Object.keys(request_body).length > 0) {
				const res_update = await update_bearer(loginToken, res_create.id, request_body);
				if(res_update.success) {
					showTemporaryMessage(t("bearer_information_successfully_updated"), "", 'success');
				} else {
					showTemporaryMessage("Update bearer FAILED!", res_update.msg, 'danger');
				}
			}
			onBearerCreated(res_create.id, name);
			setIsLoading(false);
		} catch (err) {
			showTemporaryMessage("Creating bearer FAILED!", err, 'danger');
			setIsLoading(false);
		}
	};

	const renderStep = () => {
		switch(currentStep) {
			case 1:
				// Name
				return (
					<CreateBearerStep1
						onNext={() => setCurrentStep(2)}
						onCancel={onCancel}
						setName={setName}
						name={name}
						isVerbal={isVerbal}
						setIsVerbal={setIsVerbal}
					/>
				);
			case 2:
				// Diseases
				return (
					<CreateBearerStep2
						onNext={() => setCurrentStep(3)}
						onPrevious={() => setCurrentStep(1)}
						diseases={diseases}
						setDiseases={setDiseases}
					/>
				);
			case 3:
				// Birth Year
				return (
					<CreateBearerStep3
						onNext={() => setCurrentStep(4)}
						onPrevious={() => setCurrentStep(2)}
						birthYear={birthYear}
						setBirthYear={setBirthYear}
					/>
				);
			case 4:
				// Sex
				return (
					<CreateBearerStep4
						onNext={() => setCurrentStep(5)}
						onPrevious={() => setCurrentStep(3)}
						sex={sex}
						setSex={setSex}
					/>
				);
			case 5:
				// Blood Type
				return (
					<CreateBearerStep5
						onNext={onBearerCreatedClicked}
						onPrevious={() => setCurrentStep(4)}
						bloodType={bloodType}
						setBloodType={setBloodType}
						isLoading={isLoading}
					/>
				);
			default:
				return null;
		}
	};

	return (
		<div className="flex items-center justify-center h-full w-full bg-gradient">
			{renderStep()}
		</div>
	);
}

export default CreateBearer;
